import * as constants from './constants'

export const clearEntity = entity => ({
    type: constants.CLEAR_ENTITY,
    entity,
})
